export const typeMap = {
  'AOFL.READINGIQ_PRIVATE.V1.Activity': {
    ActivityEnd: 'com.aofl.readingiq.activity.session.end'
  },
  'AOFL.READINGIQ_PRIVATE.V1.ApplicationEvent': {
    Started: 'com.aofl.readingiq.application.start'
  },
  'AOFL.READINGIQ_PRIVATE.V1.MarketingPrompt':
    'com.aofl.readingiq.marketing.prompt',
  'AOFL.READINGIQ_PRIVATE.V1.Quiz': {
    Quit: 'com.aofl.readingiq.quiz.quit',
    Skip: 'com.aofl.readingiq.quiz.skip'
  },
  'AOFL.READINGIQ_PRIVATE.V1.UserInterfaceClickEvent':
    'com.aofl.readingiq.interface.click',
  'com.aofl.readingiq.section.change':
    'com.aofl.readingiq.interface.section.change'
};
